import React from "react";

import Canceled from "./canceled";
import CustomsDuty from "./customsDuty";
import Delivered from "./delivered";
import DeliveredToLandTransport from "./deliveredToLandTransport";
import DeliveryOrdered from "./deliveryOrdered";
import DiagramNested from "./diagramNested";
import DisplacementInWarehouse from "./displacementInWarehouse";
import DrivingOrdered from "./drivingOrdered";
import DutyFree from "./dutyFree";
import Fetched from "./fetched";
import GripHorizontal from "./gripHorizontal";
import InAReceivingWarehouse from "./inAReceivingWarehouse";
import InDriving from "./inDriving";
import InTransitFlight from "./inTransitFlight";
import InTransitSea from "./inTransitSea";
import InWaiting from "./inWaiting";
import JonarArrow from "./jonarArrow";
import LandTransferOrdered from "./landTransferOrdered";
import LoadedIntoCar from "./loadedIntoCar";
import ReadyForDelivery from "./readyForDelivery";
import Registered from "./registered";
import Search from "./search";
import ShipmentUnloadedFromShip from "./shipmentUnloadedFromShip";
import WaitsCustoms from "./waitsCustoms";

const Icon = (props: { className?: string | undefined; name: string; onClick?: Function }) => {
  switch (props.name) {
    case "customsDuty":
      return <CustomsDuty {...props} />;
    case "waitsCustoms":
      return <WaitsCustoms {...props} />;
    case "deliveryOrdered":
      return <DeliveryOrdered {...props} />;
    case "delivered":
      return <Delivered {...props} />;
    case "deliveredToLandTransport":
      return <DeliveredToLandTransport {...props} />;
    case "drivingOrdered":
      return <DrivingOrdered {...props} />;
    case "canceled":
      return <Canceled {...props} />;
    case "inDriving":
      return <InDriving {...props} />;
    case "inWaiting":
      return <InWaiting {...props} />;
    case "inTransitFlight":
      return <InTransitFlight {...props} />;
    case "inTransitSea":
      return <InTransitSea {...props} />;
    case "inAReceivingWarehouse":
      return <InAReceivingWarehouse {...props} />;
    case "jonarArrow":
      return <JonarArrow {...props} />;
    case "landTransferOrdered":
      return <LandTransferOrdered {...props} />;
    case "loadedIntoCar":
      return <LoadedIntoCar {...props} />;
    case "dutyFree":
      return <DutyFree {...props} />;
    case "shipmentUnloadedFromShip":
      return <ShipmentUnloadedFromShip {...props} />;
    case "registered":
      return <Registered {...props} />;
    case "fetched":
      return <Fetched {...props} />;
    case "search":
      return <Search {...props} />;
    case "readyForDelivery":
      return <ReadyForDelivery {...props} />;
    case "displacementInWarehouse":
      return <DisplacementInWarehouse {...props} />;
    case "diagramNested":
      return <DiagramNested {...props} />;
    case "gripHorizontal":
      return <GripHorizontal {...props} />;
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>;
  }
};

export default Icon;
